/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2016] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

/**
 * This takes all the views currently rendered in the Order module (inside the sidenav section view)
 *  and performs validation on each view
 */
import _ from 'underscore';

const ValidateOrderModule = {
  views: [],
  pristine: true,

  /**
   *
   * @param {*} options
   *   calledOnReturn - if true, validation requirements may be loosened, since the order is not progressing.
   *   validateIfNotPristine - if true, validation will only happen if the form has already been validated.
   *     ie. if we want some automatic validation to occur, but only after the user has triggered validation.
   * @returns
   */
  async validate(options) {
    if (options?.validateIfNotPristine && this.pristine) {
      return true;
    }
    this.pristine = false;

    const flags = { calledOnReturn: options?.calledOnReturn, calledOnSubmit: true };

    let isValid = true;
    for (const view of this.views) {
      const val = await callValidate(view, flags);
      isValid = val && isValid;
    }
    return isValid;
  },

  // Note - reset() MUST be called when the Order Page is destroyed so that no old data is persisted between sessions
  reset() {
    this.views = [];
  }
};

async function callValidate(view, flags) {
  let isValid;
  if (_.isFunction(view.call)) {
    isValid = await view.call('validate', flags);
  } else if (_.isFunction(view.validate)) {
    isValid = await view.validate(flags);
  }
  return isValid === undefined ? true : isValid;
}

export default ValidateOrderModule;
